import { render } from "./ProjectsEdit.vue?vue&type=template&id=3e1814ae"
import script from "./ProjectsEdit.vue?vue&type=script&lang=js"
export * from "./ProjectsEdit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__